import { filter, length, map, path, pipe, prop, propOr, reduce, project } from 'ramda';
import { TSE_TOOL_CODE } from '../constants/constants';

export const tseParseJobs = rawJobs => project(['name', 'id', 'code'], rawJobs);

export const tseStepIsCompleted = (validator, jobs) => {
	const completedJobsCount = length(filter(jobItem => validator(jobItem), jobs));
	return {
		completedCount: completedJobsCount,
		totalJobsCount: length(jobs),
		isComplete: completedJobsCount === length(jobs),
	};
};

export const tseToSurvey = (selectedJobs, surveyName, answerId) => ({
	name: surveyName,
	toolCode: TSE_TOOL_CODE,
	answerId,
	factorsWeight: pipe(
		reduce((accumulator, jobItem) => {
			const skills = map(
				skillItem => ({
					...skillItem,
					jobId: prop('id', jobItem),
					jobName: prop('name', jobItem),
				}),
				propOr([], 'skills', jobItem),
			);
			return [...accumulator, ...skills];
		}, []),
		map(skillItem => ({
			id: path(['selectedLevel', 'id'], skillItem),
			name: path(['selectedLevel', 'name'], skillItem),
			typeCompetenceId: path(['parent', 'id'], skillItem),
			typeCompetenceName: path(['parent', 'name'], skillItem),
			competenceId: path(['id'], skillItem),
			competenceName: path(['name'], skillItem),
			jobId: path(['jobId'], skillItem),
			jobName: path(['jobName'], skillItem),
			questions: pipe(propOr([], 'selectedQuestions'), map(prop('id')))(skillItem),
			totalQuestions: pipe(propOr([], 'selectedQuestions'), length)(skillItem),
			questionsKpi: propOr([], 'selectedQuestions')(skillItem),
		})),
	)(selectedJobs),
});

export default {};



// WEBPACK FOOTER //
// ./src/modules/three-sixty-evaluation/utils/tse.utils.js